import 'zone.js/plugins/zone-error';
import { NdtEnvironment } from './environment.interface';
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: NdtEnvironment = {
   apiConfig: {
      baseUrl: '/api',
   },
   clientVersion: '2.*.DEV',
   externalServicesBaseUrl:
      window.origin.indexOf('localhost:') > 0 ? 'http://localhost:8196/' : `${window.origin}/external/`,
   lcsAccountId: 1,
   production: false,
   signalrBaseUrl:
      window.origin.indexOf('localhost:') > 0
         ? 'http://localhost:8193'
         : `${window.origin.replace(/^(\w+:\/\/[^.]+\.)([^.]+)(\..+)/, '$1signalr$3')}/`,
};
